let directive = {
	value_format: {
		bind: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;

			valor = vnode.context.$helper.formatValue(format, valor);

			el.innerHTML = valor;
		}
	},

	date_format: {
		bind: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;
			
			valor = vnode.context.$helper.formatDate(format, valor);

			el.innerHTML = valor;
		},

		update: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;
			
			valor = vnode.context.$helper.formatDate(format, valor);

			el.innerHTML = valor;
		}
	},

	timestamp_format: {
		bind: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;
			
			valor = vnode.context.$helper.formatTimestamp(format, valor);

			el.innerHTML = valor;
		},

		update: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;
			
			valor = vnode.context.$helper.formatTimestamp(format, valor);

			el.innerHTML = valor;
		}
	}
}


export default directive
